import { z } from 'zod';
/** Boolean predicate for any-version UUID, for use inside a `superRefine`. */
export const isValidUuid = (value) => z.uuid().safeParse(value).success;
//# sourceMappingURL=is-valid-uuid.js.map